import {mapActions, mapMutations, mapGetters, mapStates} from './../baseModule'
const collection = 'winners'
const singleName = 'winner'
const pluralName = 'winners'

const model = {
  uc: '',
  name: '',
  cpf: '',
  exchangeDate: '',
  eventPlace: ''
}

const validations = {
  uc: {required: false},
  name: {required: false},
  cpf: {required: false},
  exchangeDate: {required: false},
  eventPlace: {required: false}
}

let getters = {...mapGetters()}
getters[singleName] = state => state.one
getters[pluralName] = state => state.all
getters = Object.assign(getters, {
  loading: state => state.loading,
  validations: state => state.validations,
  count: state => state.count
})

export default {
  namespaced: true,
  state: {
    ...mapStates(),
    loading: true,
    all: [],
    one: Object.assign({}, model),
    validations: validations,
    count: 0
  },
  mutations: {
    ...mapMutations()
  },
  actions: {
    ...mapActions(collection, model, 'winners'),
    async winnerByConfig (context, {config, customer}) {
      context.commit('changeLoading', true)
      let where = []
      if (config.validationContemplatedCustomer.uc) {
        where.push({ uc: customer.uc })
      }
      if (config.validationContemplatedCustomer.cpf) {
        where.push({ cpf: customer.cpf.replace(/\D/g, '') })
      }
      if (config.validationContemplatedCustomer.ucOrCpf) {
        where = [{ '$or': where }]
      }
      if (where.length > 0) {
        const returnWinner = await context.dispatch('fetchAll', {where})
        context.commit('changeLoading', false)
        return (returnWinner) ? returnWinner[0] : false
      }
      return false
    }
  },
  getters: getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/winners.js